export const enum SortTypes {
	Name = 0,
	Company = 1,
	Manual = 2,
}
